<script lang="ts">import { onMount } from 'svelte';
import { getUrlPath } from '../../js-v2/urlUtils';
const { message, onFeedback = undefined, trackFn = undefined, } = $props();
let messageElement = $state();
const feedbackOptions = [
    { value: 'accuracy', label: 'Accuracy' },
    { value: 'clarity', label: 'Clarity' },
    { value: 'irrelevant', label: 'Irrelevant' },
    { value: 'something_else', label: 'Something else' },
];
function processMessageContent(content) {
    const template = document.createElement('template');
    template.innerHTML = content.trim();
    const links = template.content.querySelectorAll('a');
    links.forEach((link) => {
        link.setAttribute('target', '_blank');
    });
    return template.innerHTML;
}
function handlePositiveFeedback() {
    if (onFeedback) {
        onFeedback(message.id, 'positive');
    }
}
function handleNegativeFeedback() {
    if (onFeedback) {
        onFeedback(message.id, 'negative');
    }
}
function handleFeedbackReason(reason) {
    if (onFeedback) {
        onFeedback(message.id, 'negative', reason);
    }
}
onMount(() => {
    if (messageElement) {
        messageElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
        if (trackFn) {
            const messageTextElements = messageElement.querySelectorAll('.message-text');
            messageTextElements.forEach((messageTextElement) => {
                const links = messageTextElement.querySelectorAll('a');
                links.forEach((link) => {
                    link.addEventListener('click', () => {
                        trackFn({
                            eventName: 'Link Clicked in Chat',
                            properties: {
                                currentPage: getUrlPath(),
                                linkUrl: link.href,
                                linkText: link.textContent || '',
                                messageText: message.content,
                                conversationId: message.conversationId,
                            },
                        });
                    });
                });
            });
        }
    }
});
</script>

<div class="message-bubble {message.sender}" bind:this={messageElement}>
  <div class="message-content">
    <div class="message-body">
      <div class="message-text-wrapper">
        <div class="message-text">
          {#if message.isError}
            <div class="error-indicator">
              <svg
                xmlns:xlink="http://www.w3.org/1999/xlink"
                data-name="i-circle"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
                  fill="currentColor"
                ></path>
              </svg>
              <span>Issue generating answer</span>
            </div>
            <div class="error-message">
              Something went wrong while trying to answer this question. We will review this error to improve AI
              Answers, but in the meantime try rephrasing your question and asking it again.
            </div>
          {:else if message.sender === 'assistant'}
            {@html processMessageContent(message.content)}
          {:else if message.sender === 'user'}
            {message.content}
          {/if}
        </div>
      </div>
      {#if message.sender === 'assistant' && !message.isError}
        <div class="feedback-section">
          {#if message.feedback?.submitted}
            <div class="feedback-thanks">Thanks for your feedback!</div>
          {:else if message.feedback?.type === 'negative' && !message.feedback.reason}
            <div class="feedback-followup">
              <div class="feedback-question">Why wasn't it useful?</div>
              <div class="feedback-options">
                {#each feedbackOptions as option}
                  <label class="feedback-option">
                    <input
                      type="radio"
                      name={`feedback-input-${option.value}`}
                      value={option.value}
                      onchange={() => handleFeedbackReason(option.value)}
                    />
                    <span>{option.label}</span>
                  </label>
                {/each}
              </div>
            </div>
          {:else}
            <div class="feedback-buttons">
              <button
                class="feedback-btn feedback-btn-positive"
                onclick={handlePositiveFeedback}
                aria-label="This was helpful"
                title="This was helpful"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect width="24" height="24" fill="white" fill-opacity="0.01" />
                  <path
                    d="M15.4141 1C16.8578 1.00006 17.9739 2.26698 17.792 3.69922L17.1318 8.89062L19.6133 8.94629C21.4752 8.98786 22.9037 10.7301 22.375 12.6055C21.9679 14.0495 21.3541 15.9499 20.5654 17.5498C20.172 18.348 19.7141 19.1136 19.1885 19.7168C18.6738 20.3073 18.0018 20.8467 17.1641 20.9863C15.5084 21.2622 13.6341 21.1181 11.8008 20.8652C10.8764 20.7377 9.93889 20.5788 9.02637 20.4229C8.5034 20.3335 7.98892 20.246 7.48438 20.1641C7.40596 20.6381 6.99628 21 6.5 21H3C2.44772 21 2 20.5523 2 20V10C2 9.44771 2.44772 9 3 9H6.5C7.01363 9 7.43645 9.38728 7.49316 9.88574C8.6792 9.60888 9.64037 8.83253 10.4941 7.69922C11.5971 6.23503 12.4167 4.31623 13.2188 2.44434C13.5964 1.56326 14.4624 1 15.4141 1ZM15.4141 3C15.2555 3 15.1174 3.09313 15.0576 3.23242C14.281 5.04483 13.369 7.20692 12.0918 8.90234C10.9715 10.3896 9.49589 11.613 7.5 11.9229V18.1426C8.1177 18.2407 8.74399 18.3461 9.36426 18.4521C10.2796 18.6086 11.1864 18.7623 12.0742 18.8848C13.8657 19.1319 15.4917 19.2377 16.8359 19.0137C17.0155 18.9836 17.303 18.8356 17.6807 18.4023C18.0477 17.9812 18.4166 17.385 18.7715 16.665C19.4795 15.2286 20.0546 13.4657 20.4502 12.0625C20.6008 11.5278 20.2107 10.9609 19.5693 10.9463L15.9775 10.8662C15.6944 10.8599 15.427 10.7332 15.2422 10.5186C15.0574 10.304 14.9722 10.0211 15.0078 9.74023L15.8076 3.44727C15.8378 3.20998 15.6532 3.00006 15.4141 3ZM4 19H5.5V11H4V19Z"
                    fill="#959595"
                  />
                </svg>
              </button>
              <button
                class="feedback-btn feedback-btn-negative"
                onclick={handleNegativeFeedback}
                aria-label="This was not helpful"
                title="This was not helpful"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect width="24" height="24" fill="white" fill-opacity="0.01" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.8008 3.27074C13.634 3.01789 15.5085 2.87377 17.1641 3.14964C18.0016 3.28929 18.6738 3.82877 19.1885 4.41917C19.714 5.02225 20.172 5.78806 20.5654 6.58617C21.354 8.18591 21.9679 10.0865 22.375 11.5305C22.9037 13.4058 21.4751 15.148 19.6133 15.1897L17.1318 15.2453L17.792 20.4368C17.9739 21.8689 16.8577 23.1358 15.4141 23.136C14.4624 23.136 13.5964 22.5727 13.2188 21.6916C12.4167 19.8198 11.5971 17.9009 10.4941 16.4368C9.64043 15.3036 8.67908 14.5271 7.49316 14.2502C7.43645 14.7486 7.01353 15.1359 6.5 15.136H3C2.44772 15.136 2 14.6883 2 14.136V4.13597C2.00026 3.5839 2.44787 3.13597 3 3.13597H6.5C6.99603 3.13608 7.40579 3.49813 7.48438 3.97191C7.98882 3.88995 8.5035 3.8025 9.02637 3.71312C9.9388 3.55715 10.8765 3.39823 11.8008 3.27074ZM16.8359 5.1223C15.4918 4.89828 13.8656 5.00414 12.0742 5.25121C11.1864 5.37366 10.2795 5.52736 9.36426 5.68382C8.74409 5.78983 8.11761 5.89533 7.5 5.99339V12.2131C9.49572 12.523 10.9715 13.7465 12.0918 15.2336C13.3689 16.929 14.281 19.0912 15.0576 20.9035C15.1174 21.0428 15.2555 21.136 15.4141 21.136C15.6531 21.1358 15.8378 20.9259 15.8076 20.6887L15.0078 14.3957C14.9723 14.115 15.0575 13.8319 15.2422 13.6174C15.427 13.403 15.6945 13.2761 15.9775 13.2698L19.5693 13.1897C20.2105 13.1749 20.6008 12.6081 20.4502 12.0735C20.0546 10.6704 19.4794 8.90723 18.7715 7.47093C18.4166 6.75106 18.0476 6.15471 17.6807 5.73363C17.3032 5.30056 17.0155 5.15239 16.8359 5.1223ZM4 5.13597V13.136H5.5V5.13597H4Z"
                    fill="#959595"
                  />
                </svg>
              </button>
            </div>
          {/if}
        </div>
      {/if}
    </div>
  </div>

  {#if message.isCancelled}
    <div class="cancelled-indicator">
      <svg xmlns:xlink="http://www.w3.org/1999/xlink" data-name="i-circle" viewBox="0 0 24 24" width="18" height="18">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19ZM11 10.5V17H13V10.5H11ZM13.25 8.25C13.25 8.94036 12.6904 9.5 12 9.5C11.3096 9.5 10.75 8.94036 10.75 8.25C10.75 7.55964 11.3096 7 12 7C12.6904 7 13.25 7.55964 13.25 8.25Z"
          fill="currentColor"
        ></path>
      </svg>
      <span>Canceled</span>
    </div>
  {/if}
</div>

<style>@charset "UTF-8";
@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.message-bubble {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}
@media (max-width: 739px) {
  .message-bubble {
    margin-bottom: 1px;
  }
}
.message-bubble.user {
  align-items: flex-end;
}
.message-bubble.user .message-content {
  flex-direction: row-reverse;
  background: #f5f5f5;
  color: #333333;
  border-radius: 18px 18px 4px 18px;
}
.message-bubble.user .message-text {
  color: #333333;
}
.message-bubble.user .cancelled-indicator {
  align-self: flex-end;
  margin-right: 16px;
}
.message-bubble.assistant {
  align-items: flex-start;
}
.message-bubble.assistant .message-content {
  background: #ffffff;
  color: #333333;
  border-radius: 18px 18px 18px 4px;
  box-shadow: none;
}
.message-bubble.assistant .message-text {
  color: #333333;
}
.message-bubble.assistant .cancelled-indicator {
  align-self: flex-start;
  margin-left: 16px;
}

.message-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  max-width: 80%;
  padding: 12px 16px;
  position: relative;
}
@media (max-width: 739px) {
  .message-content {
    padding: 4px 8px;
    max-width: 85%;
  }
}
@media (max-width: 1023px) {
  .message-content {
    padding: 6px 12px;
    max-width: 90%;
  }
}

.message-body {
  flex: 1;
  min-width: 0;
}

.message-text-wrapper {
  position: relative;
}

.message-text {
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 14px;
}
.message-text :global(p) {
  font-size: 14px;
}
.message-text :global(strong) {
  font-weight: 600;
}
.message-text :global(em) {
  font-style: italic;
}
.message-text :global(code) {
  background: rgba(0, 0, 0, 0.1);
  padding: 2px 4px;
  border-radius: 4px;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.9em;
}
.message-text :global(a) {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  position: relative;
}
.message-text :global(a):hover {
  opacity: 0.8;
}
.message-text :global(a)::after {
  content: "↗";
  display: inline;
  margin-left: 2px;
  font-size: 0.9em;
  text-decoration: underline;
}
.message-text :global(ul),
.message-text :global(ol) {
  margin: 8px 0;
  padding-left: 20px;
}
.message-text :global(ul > li),
.message-text :global(ol > li) {
  padding-left: 0.25em;
}
.message-text :global(ul > li::before) {
  content: none;
}
.message-text :global(ul) {
  list-style-type: disc;
}
.message-text :global(ol) {
  list-style-type: decimal;
}
.message-text :global(li) {
  margin: 4px 0;
  line-height: 1.4;
}
.message-text :global(table) {
  border-collapse: collapse;
  width: 100%;
  margin: 12px 0;
  font-size: 14px;
}
.message-text :global(th),
.message-text :global(td) {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: left;
  vertical-align: top;
}
.message-text :global(th) {
  background-color: #f8f9fa;
  font-weight: 600;
  border-bottom: 2px solid #ccc;
}
.message-text :global(tr:nth-child(even)) {
  background-color: #f8f9fa;
}
.message-text :global(tr:hover) {
  background-color: #e9ecef;
}

.error-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: #666666;
}

.cancelled-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  color: #6c757d;
}
.cancelled-indicator svg {
  flex-shrink: 0;
  color: #6c757d;
}
.cancelled-indicator span {
  font-weight: 400;
}

.feedback-section {
  margin-top: 8px;
  padding-top: 8px;
}
@media (max-width: 739px) {
  .feedback-section {
    margin-top: 2px;
    padding-top: 2px;
  }
}

.feedback-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.feedback-btn {
  --letter-spacing: var(--text-variant-100-letter-spacing);
  --line-height: var(--text-variant-100-line-height);
  --font-size: var(--text-variant-100-font-size);
  --font-weight: var(--text-variant-100-font-weight);
  --font-family: var(--text-font-family);
  --max-width: var(--text-variant-100-max-width);
  color: var(--color-text);
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  letter-spacing: var(--letter-spacing);
  line-height: var(--line-height);
  max-width: var(--max-width);
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, var(--color-neutral-000, #000000));
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: pointer;
  color: rgb(16, 16, 16);
  transition: all 0.2s ease;
}
.feedback-btn:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: var(--accessibility-focus-outline-border-radius);
  outline-offset: var(--accessibility-focus-outline-offset);
}
.feedback-btn:focus {
  background: transparent;
  outline: none;
}
.feedback-btn:hover {
  background: transparent;
}
.feedback-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #333333;
}
.feedback-btn:focus {
  outline: 2px solid rgba(0, 106, 255, 0.5);
  outline-offset: 2px;
}
.feedback-btn svg {
  transition: transform 0.2s ease;
}
.feedback-btn:hover svg {
  transform: scale(1.1);
}

.feedback-thanks {
  font-size: 12px;
  color: #666666;
  font-style: italic;
}

.feedback-followup .feedback-question {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 12px;
}
.feedback-followup .feedback-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.feedback-followup .feedback-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #333333;
}
.feedback-followup .feedback-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #006aff;
  appearance: auto;
  -webkit-appearance: radio;
  -moz-appearance: radio;
}
.feedback-followup .feedback-option span {
  cursor: pointer;
}
.feedback-followup .feedback-option:hover {
  color: #000000;
}</style>
